module.exports = __webpack_public_path__ + "img/payments.1463a5d2.png";